import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import { smallBoxShadow } from 'globals/styles';
import { FsComponentSize } from 'globals/types';

const sizeBig = 80;
const sizeBigMobile = 60;
const sizeSmall = 32;

interface LogoWrapperBoxProps extends BoxProps {
  size?: FsComponentSize.S | FsComponentSize.M;
}

export const LogoWrapperBox = withStyles(
  ({ spacing, breakpoints, palette }: Theme) => ({
    root: {
      width: sizeBig,
      padding: spacing(0.5),
      marginBottom: spacing(2),
      backgroundColor: palette.common.white,
      '& > img': {
        display: 'block',
        width: `100%`,
        height: 'auto',
      },
      [breakpoints.up('sm')]: {
        width: sizeBigMobile,
        marginBottom: 0,
        marginRight: spacing(2),
      },
      '&.small': {
        width: sizeSmall,
        marginRight: spacing(1),
        marginBottom: 0,
      },
    },
  })
)(({ size, ...otherProps }: LogoWrapperBoxProps) => {
  return (
    <Box
      {...otherProps}
      style={{ boxShadow: smallBoxShadow }}
      className={cn({ small: size === FsComponentSize.S })}
    />
  );
});
